import React from 'react'
import Skeleton from '@material-ui/lab/Skeleton'
import { Tabs } from '@material-ui/core'
import MobileScreen from 'mobile/components/MobileScreen'
import { MobileAppBar, MobileTab, TabPanel } from 'mobile/utils'

import SearchFields from './components/SearchFieldSkeleton'

const SalesOrderSkeleton = () => {

  return (
    <MobileScreen
      speedDialActions={[]}
      title="Sales Order Entry"
      titleIcon="shopping_cart"
      CollapsableSearchComponent={SearchFields}
    >
      <div style={{ width: '100%' }}>
        <MobileAppBar position="static">
          <Tabs
            value={0}
            variant="fullWidth"
          >
            <MobileTab label="Line Items" />
            <MobileTab label="Order Info" />
          </Tabs>
        </MobileAppBar>
        <div style={{ width: '100%' }}>
          <TabPanel value={0} index={0}>
            <Skeleton animation="wave" variant="rect" width="100%" height="250" />
          </TabPanel>
          <TabPanel value={0} index={0}>
            <Skeleton animation="wave" variant="rect" width="100%" height="250" />
          </TabPanel>
        </div>

      </div>
    </MobileScreen>
  )
}

export default SalesOrderSkeleton